export default __webpack_public_path__ + "static/media/recent-activity-artwork-5.32075896.png";